import { TermsDataType } from '@/types/terms.type';

export const termsOfServiceData: TermsDataType[] = [
  {
    title: '도로로 서비스 이용약관\n\n',
    title1: '제 1장 총칙',
    title2: '제1조 목적',
    discription1:
      '(주)애드락애드버테인먼트(이하 “회사”라 합니다)는 회사가 제공하는 서비스에 대한 약관(이하 ‘본 약관’이라 합니다)을 마련하였습니다. 본 약관은 회사와 회원의 권리와 의무, 책임관계, 기타 필요한 사항을 규정하고 있습니다.',
    lineBreak: true,
  },
  {
    title2: '제2조 정의',
    discription2: [
      [
        '1.',
        '도로로 : 회원이 PC, 휴대전화 등을 통하여 운전 교육 및 연수 서비스를 이용할 수 있도록 회사가 제공하는 일체의 어플리케이션을 말합니다.',
      ],
      [
        '2.',
        '도로로 서비스 : 도로로를 통해서 제공하는 일체의 운전 교육 및 연수 서비스를 의미합니다.',
      ],
      [
        '3.',
        '구체적인 서비스의 종류 및 내용은 제8조(도로로 서비스의 내용)에서 정하고 있습니다.',
      ],
      [
        '4.',
        '회원 : 본 약관에 동의하고 회사가 제공하는 도로로 서비스를 이용하는 고객을 말합니다.',
      ],
      [
        '5.',
        '유료서비스 : 도로로 서비스 중 회원이 운전학원, 운전연수 강사, 실내운전연습장 등(이하 통칭하여 “서비스 제공자”라 합니다)에게 운임, 요금, 이용료, 수수료 등(이하 통칭하여 “이용요금”이라 합니다)을 지급하는 서비스를 말합니다.',
      ],
      [
        '6.',
        '제휴서비스: 운전면허전문학원, 실내운전연습장 등 회사와 제휴한 사업자(이하 “제휴사"라 합니다)가 도로로를 통해 제공하는 유료서비스를 말합니다.',
      ],
      [
        '7.',
        '자동결제: 회원이 최초 결제수단 등의 정보를 입력한 이후 이용요금이 결제될 때마다 별도의 인증과정 없이 자동으로 결제되는 것을 말합니다. 자동결제와 관련한 상세한 정책은 개별 전자지급결제대행업자의 결제서비스 이용약관 및 서비스정책을 따릅니다.',
      ],
      [
        '8.',
        '도로로 포인트: 회원이 직접 유상 결제하는 등의 방법으로 충전하거나 도로로 서비스 이용 등을 통해서 적립 받아 도로로를 통해 제공하는 유료서비스 결제시 사용할 수 있는 전자적 지급수단을 말합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제3조 약관의 효력 및 변경',
    discription2: [
      [
        '1.',
        '본 약관의 내용은 도로로 화면에 게시하거나 기타의 방법으로 회원에게 공시하고, 본 약관에 동의한 회원에게 그 효력이 있습니다.',
      ],
      [
        '2.',
        '회사는 필요한 경우 관련법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다. 회사가 본 약관을 변경할 경우에는 적용일자, 변경사유를 명시하여 적용일자 7일 전부터 공지하거나, 회원에게 개별 통지합니다. 회원에게 불리한 약관의 변경인 경우에는 그 적용일자 30일 전부터 공지합니다. 다만, 해당 내용이 중대한 경우에는 제5조 제1항 전단에서 정한 방법으로 개별 통지합니다.',
      ],
      [
        '3.',
        '회사가 제2항에 따라 회원에게 공지 또는 통지를 하면서 ‘약관 변경 적용일까지 거부의사를 표시하지 않을 경우 약관의 변경에 동의한 것으로 본다’는 내용을 명확하게 고지하였음에도 회원이 명시적으로 약관 변경에 대한 거부의사를 표시하지 않은 경우 회원은 변경된 약관 내용에 동의한 것으로 봅니다.',
      ],
      [
        '4.',
        '회원이 변경된 약관 사항에 동의하지 않으면 회사는 개정 약관의 내용을 적용할 수 없고, 회원은 도로로 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다. 다만, 회사는 개정약관에 부동의한 회원에게 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 해당 회원과의 이용계약을 해지할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제4조 약관의 해석 및 약관 외 준칙',
    discription2: [
      [
        '1.',
        '회사는 필요한 경우 개별 도로로 서비스에 관하여 적용될 사항을 위해 운영정책, 이용지침 등(이하 통칭하여 "운영정책 등"이라 합니다)을 정하여 운영할 수 있습니다. 해당 내용은 도로로 화면, 홈페이지 등을 통해 공지합니다.',
      ],
      [
        '2.',
        '본 약관에 규정되지 않은 사항에 대해서는 관련법령 또는 운영정책 등에서 정한 바에 따릅니다.',
      ],
      [
        '3.',
        '회원은 본 약관 및 운영정책 등의 내용에 변경이 있는지 여부를 확인하여야 합니다. 회사는 회원이 이를 확인하지 않아 발생한 손해에 대해서는 책임을 부담하지 않습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제5조 회원에 대한 통지 등',
    discription2: [
      [
        '1.',
        '회사는 회원이 등록한 E-mail 주소 또는 SMS, App push 등을 통해 회원에 대한 통지를 할 수 있습니다. 다만, 회사가 불특정 다수 회원에 대해 통지를 하는 경우 도로로 화면에 게시하는 방법 등을 활용할 수 있습니다.',
      ],
      [
        '2.',
        '회사는 도로로 서비스를 운영함에 있어서 도로로 서비스 관련 각종 정보를 개별 도로로 화면에 게시하거나 제1항에 정한 방법으로 회원에게 제공할 수 있습니다.',
      ],
      [
        '3.',
        '회사는 도로로 서비스를 운영하면서 회사 또는 제휴사의 각종 광고를 도로로 화면에 게시하거나 회원의 동의를 얻어 제1항에 정한 방법으로 회원에게 제공할 수 있습니다.',
      ],
      [
        '4.',
        '회원의 연락처 미기재, 변경 후 미수정 등으로 인하여 개별 통지가 어려운 경우 제1항 단서의 공지를 함으로써 개별 통지를 한 것으로 봅니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제6조 면책사항',
    discription2: [
      [
        '1.',
        '회사가 도로로 회원에게 직접 또는 회사로부터 업무를 위탁받은 자를 통하여 서비스를 제공한 경우에는 회사가 거래당사자로서 성립된 거래와 관련한 정보, 서비스, 이용료 등에 대한 책임을 부담합니다. 다만, 회원이 도로로를 통해 서비스 제공자 간의 거래를 중개하는 서비스를 이용할 경우 회사는 회원과 서비스 제공자 간의 거래를 중개하는 시스템을 운영•관리•제공할 뿐, 회원을 포함한 거래당사자(제휴사, 운전연수 제공자 등 포함)들을 대리하지는 않습니다.',
      ],
      [
        '2.',
        '회원의 도로로 서비스 이용 과정에서 발생한 회원 상호간 또는 회원과 제3자 상호간에 발생한 분쟁(도로로 서비스 이용 중에 발생한 사고, 서비스와 무관하게 발생한 범죄행위 등을 포함하나 이에 한정하지 않음)에 대해서는 회사의 과실이 없는 한 개입하지 않으며 책임을 부담하지 않습니다. 다만, 제1항 단서의 경우, 해당 분쟁이 거래당사자로서의 책임과 관련이 있는 경우에는, 회사는 거래당사자로서의 책임을 다합니다.',
      ],
      [
        '3.',
        '회사는 회원과 서비스 제공자 간의 거래와 관련하여 서비스 신청의사 또는 수락의사의 존부 및 진정성, 거래 대상의 품질, 완전성, 안전성, 적법성 및 타인의 권리에 대한 비침해성, 회원 또는 서비스 제공자가 제공 및 게시한 정보 및 그 정보의 진실성, 적법성 및 타인의 권리에 대한 비침해성 등 일체에 대하여 보증하지 않고, 그와 관련하여 회사의 고의 또는 과실이 없는 한 어떠한 책임도 부담하지 않습니다. 다만, 제1항 단서의 경우, 회사는 회사가 거래당사자로서 회원에게 제공한 정보에 대하여는 그 진실성 또는 적법성 등에 대하여 거래당사자로서 책임을 부담합니다.',
      ],
      [
        '4.',
        '회사는 회원이 도로로에 입력한 정보, 자료, 사실의 신뢰도 및 정확성 등의 내용과 관련하여 회사의 고의 또는 과실이 없는 한 책임을 부담하지 않습니다. 또한 회사는 도로로 화면 내에서 링크, 배너 등을 통하여 연결된 제3자와 회원 간의 거래 등에 관하여 개입하지 않고, 해당 거래 등에 대하여 회사의 고의 또는 과실이 없는 한 어떠한 책임도 부담하지 않습니다.',
      ],
      [
        '5.',
        '회사의 고의 또는 과실로 인하여 회원이 손해를 입게될 경우, 회사는 본 약관 및 관련법령에 따라 회원의 손해를 배상합니다. 다만, 회사는 회사의 고의 또는 과실 없이 발생된 아래와 같은 손해에 대해서는 책임을 부담하지 않습니다.',
      ],
    ],
    discription3: [
      [
        'a.',
        '관계법령의 변경, 천재지변, 기간통신사업자의 회선 장애 또는 이에 준하는 불가항력으로 인하여 도로로 서비스를 제공할 수 없게되어 발생한 손해',
      ],
      [
        'b.',
        '회원이 불법행위 또는 부적절한 방법으로 도로로 서비스를 이용하여 발생한 제반 결과(서비스 이용 불능, 각종 사고 등)로 인한 손해',
      ],
      [
        'c.',
        '회원의 도로로 서비스 이용 과정에서 불법행위 등이 의심되어 거래당사자로 하여금 수사기관 제보 등 조치를 안내함으로써 발생한 제반 결과(서비스 이용 지연 또는 불능, 각종 사고 등)로 인한 손해',
      ],
      [
        'd.',
        '회원이 도로로 서비스를 이용하여 기대하는 수익을 상실하였거나 도로로 서비스를 통하여 얻은 2차적인 자료로 인하여 발생한 손해',
      ],
      [
        'e.',
        '회원의 교통법규 위반 및 부주의 등으로 발생하는 회원 또는 제3자의 손해',
      ],
      ['f.', '그 밖에 회사가 예상할 수 없는 회원의 손해'],
    ],
    lineBreak: true,
  },
  {
    title1: '제 2장 도로로의 이용',
    title2: '제7조 도로로 가입',
    discription2: [
      [
        '1.',
        '도로로에 가입하고자 하는 자는 유효하고 적법한 신원 정보를 보유한 상태에서 본 약관에 동의하여 도로로 가입절차를 진행함으로써 이용신청을 하고, 회사가 이를 승낙함으로써 도로로와의 이용계약이 체결됩니다.',
      ],
      [
        '2.',
        '제1항에 따라 가입절차를 진행하고자 하는 자는 회사에서 제공하는 회원가입 신청 양식에 따라 필요사항을 기재하여야 합니다. 회원 가입시 기재 항목은 필수 기재 항목과 선택 기재 항목으로 구분되어 있고, 필수 기재 항목의 경우 반드시 입력을 하여야 합니다.',
      ],
      [
        '3.',
        '회사는 제1항에 따른 가입절차의 진행 과정에서 실명확인 또는 본인인증 등 절차의 진행을 요구할 수 있습니다. 도로로에 가입을 하여 이용하고자 하는 자는 회사가 요구하는 절차를 거쳐야 합니다.',
      ],
      [
        '4.',
        '회사는 원칙적으로 제1항에 따른 이용신청을 승낙합니다. 다만, 회사는 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지 않거나 사후적으로 이용계약을 해지할 수 있습니다.',
      ],
    ],
    discription3: [
      ['a.', '가입 시 사용한 신원 정보가 유효하지 않는 경우'],
      ['b.', '타인의 명의를 이용하여 이용신청을 한 경우'],
      ['c.', '14세 미만의 아동이 이용신청을 한 경우'],
      [
        'd.',
        '회사가 요구하는 실명확인 또는 본인인증 등 절차를 거치지 않았거나, 허위 또는 부적절한 방법으로 거친 경우',
      ],
      [
        'e.',
        '이용신청 과정에서 허위의 정보를 기재하였거나, 회사가 요구하는 기재 항목을 기재하지 않거나 오기한 경우',
      ],
      [
        'f.',
        '어떠한 사유로 이전에 회원 자격을 박탈당하였거나 이용계약을 해지당하였던 자가 이용신청을 한 경우',
      ],
      [
        'g.',
        '어떠한 사유로 이용정지 등의 제재를 받은 회원이 그 제재기간 중에 탈퇴 등을 통하여 이용계약을 임의로 해지한 후 이용신청을 한 경우',
      ],
      [
        'h.',
        '본 약관 또는 관련법령 등에 위배되거나 회사가 정한 이용신청 요건을 충족하지 못하는 등 위법 또는 부적절한 이용신청임이 확인된 경우',
      ],
      [
        'i.',
        '회사의 사업 운영, 사회의 안녕질서 또는 미풍양속을 저해하거나 저해할 목적으로 이용신청을 한 경우',
      ],
      [
        'j.',
        '기타 제a호 내지 제g호에 준하는 사유 또는 이용신청을 한 자의 귀책사유로 인하여 회사가 승낙할 수 없는 경우',
      ],
    ],
  },
  {
    discription2: [
      [
        '5.',
        '회사는 기술상 또는 설비상 문제가 있는 경우에는 이용신청에 대한 승낙을 보류하거나 거절할 수 있습니다.',
      ],
      [
        '6.',
        '회사가 본 조에 따라 이용신청의 승낙을 보류하거나 거절하는 경우, 회사는 부득이한 사유가 없는 한 관련사항을 제5조(회원에 대한 통지 등)에 준하는 방법으로 해당 신청자에게 통지합니다.',
      ],
      [
        '7.',
        '회원이 본 이용약관에 동의하고 도로로에 가입하는 것은, 도로로 및 도로로 서비스를 회사에서 제공하는 방식과 내용으로 이용하고 회사에서 정한 본 약관 및 운영정책 등을 준수한다는 의사를 표시한 것으로 간주됩니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제8조 도로로 서비스의 내용',
    discription2: [['1.', '도로로 서비스의 종류와 내용은 다음과 같습니다.']],
    discription3: [
      [
        'a.',
        '실내운전연습 : 회원이 지정한 위치에서 가장 가까운 지점의 실내운전연습장 정보를 제공하고 매장 예약 및 이용을 중계하는 서비스',
      ],
      [
        'b.',
        '운전연수 : 교육용 차량 이용과 운전 강사로부터 기초 운전 교육을 받을 수 있는 운전연수 서비스를 제공하거나 중계',
      ],
      [
        'c.',
        '커뮤니티 서비스: 회원이 게시물을 게시하고 댓글을 달면서 회원 간에 정보를 공유하거나 대화할 수 있도록 게시판을 제공하는 서비스',
      ],
      [
        'd.',
        '기타 회사가 회원의 이동, 다양한 경험/체험 등을 위해 제공하는 중개 서비스',
      ],
    ],
  },
  {
    discription2: [
      [
        '2.',
        '회사는 회원의 도로로 서비스 이용에 있어 회원의 편의를 도모하고 서비스 이용의 효율을 높이기 위해 다양한 유료서비스를 구성하여 제공할 수 있고, 구체적인 사항은 제11조(유료서비스의 이용)에 따릅니다.',
      ],
      [
        '3.',
        '회사는 제휴사가 제공하는 다양한 제휴서비스를 도로로를 통하여 제공할 수 있습니다. 제휴서비스 이용과 관련하여서는 제휴사의 이용약관을 따르고, 회사는 회원이 해당 이용약관을 확인할 수 있도록 제휴사의 홈페이지 등에 게시되어 있는 이용약관을 연결합니다. 또한 회사는 회원이 제휴서비스를 이용하기 전에 도로로 화면을 통하여 이용요금 등을 안내합니다.',
      ],
      [
        '4.',
        '제1항에 따른 도로로 서비스의 이용방법 및 이용상 주의사항 등은 도로로를 통한 각 서비스 이용시 화면을 통하여 안내하거나, 도로로 내 공지사항 또는 운영정책 등을 통하여 공지합니다.',
      ],
      [
        '5.',
        '회사는 제1항의 각 도로로 서비스를 개별 어플리케이션을 통해 제공할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제9조 도로로 서비스의 변경 등',
    discription2: [
      [
        '1.',
        '회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부의 서비스를 추가하거나 축소하는 등 변경할 수 있습니다. 다만, 변경된 내용이 중대하거나 회원에게 불리한 경우에는 회사가 해당 서비스를 제공받는 회원에게 제5조 제1항 전단에서 정한 방법으로 개별 통지합니다.',
      ],
      [
        '2.',
        '회사는 전항에 따른 서비스 변경에 대한 동의를 거절한 회원에 대하여는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 이용계약을 해지할 수 있습니다.',
      ],
      [
        '3.',
        '회사는 다음 각 호에 해당하는 경우 도로로 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.',
      ],
    ],
    discription3: [
      [
        'a.',
        '통신, 전력 등의 공급이 중단되거나 정보통신설비의 보수점검, 증설, 교체, 이전, 고장, 장애 또는 운영상 상당한 이유가 있는 경우',
      ],
      [
        'b.',
        '도로로 서비스 제공을 위한 제3자와의 계약 종료 또는 경영상의 판단 등 회사의 제반 사정으로 도로로 서비스를 유지할 수 없는 경우',
      ],
      ['c.', '파산 또는 회생절차 개시 등 정상적인 영업활동이 곤란한 경우'],
      [
        'd.',
        '기타 천재지변, 전쟁 및 폭동, 테러 등 국가비상사태, 해킹, DDOS 공격 등 불가항력적 사유가 있는 경우',
      ],
    ],
  },
  {
    discription2: [
      [
        '4.',
        '회사는 제3항에 의한 도로로 서비스 제한 또는 중단의 경우 제5조에서 정한 방법으로 회원에게 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인하여 사전 통지가 불가능한 경우에는 그 사유가 종료된 후 즉시 통지합니다.',
      ],
      [
        '5.',
        '회사는 본 조에 따른 도로로 서비스의 변경, 제한, 중단 등으로 발생하는 문제에 대해서 회사에 귀책사유가 없으면 책임을 부담하지 않습니다.',
      ],
      [
        '6.',
        '회사는 정기점검을 실시할 수 있고, 정기점검시 도로로 서비스의 전부 또는 일부가 중단될 수 있습니다. 회사는 점검시간 등 상세사항을 도로로 내의 공지사항 또는 각 서비스별 화면 등에 공지합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제10조 이용계약해지 및 이용제한',
    discription2: [
      [
        '1.',
        '회원은 언제든지 회사에 이용계약 해지의 의사를 통지함으로써 이용계약을 해지할 수 있습니다. 다만, 회원은 해지의사를 통지하기 전에 현재 진행 중인 모든 유료서비스의 거래를 완료하거나 철회 또는 취소하여야 하며, 유상으로 구매한 도로로 서비스 내 포인트 잔액을 환급받아야 합니다. 만일 결제실패에 따른 미수가 있을 경우에는, 회원은 해당 결제를 완료한 후 해지의사를 통지하여야 합니다.',
      ],
      [
        '2.',
        '회사는 제1항에 따른 이용계약 해지로 인해 발생할 수 있는 불이익 등에 대하여 귀책사유가 없으면 책임을 부담하지 않습니다. 회사가 이용계약에 기초하여 회원에게 무상으로 지급한 도로로 포인트 및 혜택은 이용계약 해지와 함께 소멸됩니다.',
      ],
      [
        '3.',
        '회사는 도로로 회원 가입 후 3개월 동안 도로로 서비스 사용 이력이 없는 회원에 대하여는, 일정 기간을 정하여 사용의사를 확인한 후 이용계약을 종료할 수 있습니다.',
      ],
      [
        '4.',
        '회원의 귀책사유로 인하여 이용계약이 해지되더라도 해지 이전에 이미 시작된 도로로 서비스 이용 건에 대하여는 본 약관이 계속 적용됩니다.',
      ],
      [
        '5.',
        '회원의 귀책사유로 인하여 이용계약이 해지됨으로써 발생한 손해는 당해 회원이 부담하여야 합니다.',
      ],
      [
        '6.',
        '서비스 이용이 제한된 회원은 해당 제한 내용에 따라 도로로 서비스를 이용할 수 없으며, 이용제한 등 제재를 받은 회원이 그 제재기간 중에 이용계약의 해지를 요청하는 경우 회사는 이용계약의 해지를 거부할 수 있습니다.',
      ],
      [
        '7.',
        '회사는 회원이 본 약관에 따른 의무를 위반하는 경우 서비스 이용을 제한하거나 이용계약을 해지할 수 있고, 그에 따라 발생하는 책임은 회사의 고의 또는 과실이 없는 한 회원이 부담합니다. 회사는 필요한 경우 회원의 위반행위를 관련 정부기관 또는 사법기관에 통지할 수 있습니다.',
      ],
      [
        '8.',
        '회사가 본 조항에 따라 서비스 이용을 제한하거나 이용계약을 해지하는 경우, 회사는 제5조에서 정한 방법으로 사전에 회원에게 통지합니다. 단, 부득이한 사유로 인하여 사전 통지가 불가능한 경우에는 그 사유가 종료된 후 즉시 통지합니다.',
      ],
      [
        '9.',
        '회원은 전항의 통지일로부터 10일 이내에 항변 및 소명을 할 수 있고, 해당 항변 및 소명이 정당한 경우 회사는 서비스 이용 제한 또는 이용계약 해지를 취소할 수 있습니다.',
      ],
      [
        '10.',
        '회원이 이용계약을 해지하더라도 회원이 해지 전에 커뮤니티 서비스를 활용하여 게시한 게시물과 댓글은 삭제되지 않으며, 이용계약이 해지된 후, 회원은 자신이 게시한 게시물과 댓글을 삭제하거나 수정할 수 없습니다. 삭제나 수정을 원하는 게시물 및 댓글이 있다면 회원이 반드시 해지 전에 직접 삭제나 수정을 하여야 합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title1: '제 3장 유료서비스의 이용',
    title2: '제11조 유료서비스의 이용',
    discription2: [
      [
        '1.',
        '회사는 회원이 유료서비스 이용시 회원이 이해하고 실수 또는 착오 없이 거래할 수 있도록 해당 유료서비스의 정보를 제공합니다.',
      ],
      [
        '2.',
        '회원이 유료서비스 이용시 지급하여야 이용료 등은 이용하는 유료서비스의 내용에 따라 다르고, 회사는 개별 유료서비스 이용요금의 세부 조건을 서비스 홈페이지 등을 통해서 안내합니다.',
      ],
      [
        '3.',
        '유료서비스 이용시 취소수수료가 발생할 수 있고, 회사는 개별 유료서비스의 취소수수료 발생 조건 및 취소수수료 금액 등의 세부 조건을 서비스 홈페이지 등을 통해서 안내합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제12조 결제의 이용',
    discription2: [
      [
        '1.',
        '회원은 회사가 정한 각 서비스 별 이용정책에 따라 도로로를 통한 자동결제 또는 현장에서 서비스 제공자에 대한 직접 결제(이하 “현장결제"라 합니다) 중 가능한 방법을 선택하여 도로로 서비스 이용요금을 결제할 수 있습니다.',
      ],
      [
        '2.',
        '회원이 자동결제를 이용하는 경우, 다음 각 호에 동의한 것으로 간주합니다.',
      ],
    ],
    discription3: [
      [
        'a.',
        '자동결제 이용에 동의한 회원은 도로로 서비스 이용요금에 대해 별도의 인증과정 없이 결제를 하겠다는 의사표시를 한 것으로 봅니다.',
      ],
      [
        'b.',
        '자동결제 시점에 회원의 신용카드 등의 유효성, 한도 등의 문제로 결제실패가 발생한 경우에 미수로 처리되며, 해당 미수 금액이 정상적으로 결제되기 전까지는 해당 회원은 서비스 이용이 제한됩니다.',
      ],
      [
        'c.',
        '제b호에 따라 미수가 발생한 경우, 회사는 회사가 정한 정책에 따라 회원에 대한 별도 고지 없이 회원이 등록한 결제수단으로 재결제 시도를 진행할 수 있습니다.',
      ],
      [
        'd.',
        '결제 시점에 시스템 장애로 인하여 결제 실패가 된 경우에는, 시스템 정상화가 된 시점에 회원에 대한 별도 고지 없이 다시 결제를 진행합니다.',
      ],
    ],
  },
  {
    discription2: [
      [
        '3.',
        '회원은 자동결제 방법으로 이용요금을 결제한 경우, 기 사용된 결제수단을 다른 결제수단으로 변경하여 재결제를 요청할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제13조 환불',
    discription2: [
      [
        '1.',
        '회원의 귀책사유 없이 시스템 오류 등 정상적으로 도로로 서비스를 이용하지 못하거나 초과결제⬝중복결제 등의 문제가 발생한 경우, 회사는 해당 서비스의 정상적인 이용을 전제로 부과된 이용요금 또는 잘못 결제된 부분을 해당 회원에게 환불합니다.',
      ],
      [
        '2.',
        '회원이 이용료의 적정성에 대한 이의를 제기하거나 환불 요청을 하고자 하는 경우 직접 거래당사자에게 하여야 합니다. 다만, 회사가 회원에게 직접 또는 회사로부터 업무를 위탁받는 자를 통하여 서비스를 제공한 경우에는 회사에 이의를 제기하거나 환불 요청을 할 수 있습니다.',
      ],
      [
        '3.',
        '회사는 회원이 지불한 결제수단과 동일한 수단으로 환불합니다. 다만, 동일한 수단으로 환불이 불가능한 경우 현금 등 다른 수단으로 환불할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title1: '제 4장 이용계약 당사자의 의무',
    title2: '제14조 회사의 의무',
    discription2: [
      [
        '1.',
        '회사는 관련법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않고, 회원들에게 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다합니다.',
      ],
      [
        '2.',
        '회사는 도로로 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하고, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 제5조에서 정한 방법으로 통지합니다.',
      ],
      [
        '3.',
        '회사는 회원이 커뮤니티 서비스를 활용하여 작성 및 게시한 게시물 및 댓글의 저작권 등 지식재산권이 회원에게 있음을 확인합니다. 회사가 회원의 게시물 및 댓글을 사용, 저장, 수정, 복제, 공중송신, 전시, 배포 등의 방법으로 사용할 경우, 회사의 서비스를 운영, 개선, 홍보하고 새로운 서비스를 연구∙개발하는 목적 범위 내에서만 사용합니다.',
      ],
      [
        '4.',
        '회사는 회원의 게시물 및 댓글이 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 저작권법 등 관련 법령에 위반되는 내용을 포함하고 있음을 인지한 경우, 관련 법령에 따라 조치합니다. 또한 권리자는 회사에 관련 법령이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제15조 회원의 의무',
    discription2: [
      [
        '1.',
        '회원은 도로로 서비스를 이용 하기 전에 개별 서비스, 유료서비스, 제휴서비스 등의 이용방법 및 조건 등을 확인하여야 합니다.이용방법 및 조건 등을 확인하지 않고 서비스를 이용하여 발생한 손실, 손해에 대한 책임은 회원 본인이 부담하여야 합니다.',
      ],
      [
        '2.',
        '회원은 본 약관 및 회사가 서비스와 관련하여 통지 또는 고지하는 내용과 관련법령 등을 준수하여야 하며, 본 약관 및 통지 또는 고지 내용이나 관련법령을 위반하거나 이행하지 아니하여 발생하는 손실, 손해에 대한 책임은 회원 본인이 부담하여야 합니다. 회사는 필요한 경우 회원의 관련법령 등의 위반사실을 정부기관 또는 사법기관에 직접 통지하거나, 이러한 위반사실을 인지한 거래당사자에게 수사기관 제보 등 적절한 조치를 취할 것을 안내할 수 있습니다.',
      ],
      [
        '3.',
        '도로로 서비스와 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 회원이 부담하여야 합니다.',
      ],
      [
        '4.',
        '회원은 계정 관리를 철저히 하고 이를 제3자에게 이용하게 해서는 안되며, 회원 본인의 계정을 도난 당하거나 제3자가 사용하고 있음을 인지하는 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우 그에 따라야 합니다. 회사의 고의 또는 과실이 없는 한, 회원의 계정 관리소홀, 부정사용 등에 의하여 발생하는 책임과 불이익은 회원이 부담하여야 합니다.',
      ],
      [
        '5.',
        '회원은 운임, 유료서비스 및 제휴서비스 등에 대한 결제 시 반드시 정당하고 적법한 사용권한을 가진 결제수단을 사용하여야 하며, 회사는 그 여부를 확인할 수 있습니다. 회사는 회원 결제수단의 적법성 등에 대한 확인이 완료될 때까지 도로로 서비스의 제공을 중단할 수 있고, 적법한 권한 없는 결제수단을 임의로 사용함으로써 발생하는 회사, 결제수단의 적법한 소유자, 전자결제대행업자 또는 서비스 제공자 등의 손실과 손해에 대한 책임은 회원에게 있습니다.',
      ],
      [
        '6.',
        '회원은 게시물 및 댓글을 작성할 경우, 게시물에 대한 사용, 저장, 수정, 복제, 공중송신, 전시,배포 등의 방식으로 이용할 수 있도록 사용하는 전 세계적인 라이선스를 회사에 제공하고, 회사의 서비스를 운영, 개선, 홍보하고 새로운 서비스를 연구∙개발하는 목적 범위 내에서 회사의 계열사, 회사와 명시적인 업무계약을 체결한 상대방 또는 다른 이용자에 대하여 서브라이선스를 부여하는 것에 동의합니다. 회원은 회사가 서비스를 안전하게 제공할 수 있도록 협조하여야 하며, 회사가 회원의 본 약관 위반 등 부적절한 행위를 발견하여 회원에게 해당 행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야 합니다.',
      ],
      [
        '7.',
        '회원은 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며, 분쟁해결에 대한 회원의 불성실로 인하여 서비스 제공자 또는 회사에 손해가 발생한 경우 회원은 이에 대한 책임을 부담하여야 합니다.',
      ],
      [
        '8.',
        '회원은 회사가 정하고 인정하는 방식에 따라 도로로 포인트 및 혜택 등을 취득, 사용하여야 합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제16조 회원의 금지사항',
    discription1:
      '회사는 도로로 서비스의 신뢰성을 제고하고 안전한 거래가 이루어질 수 있도록 회원의 다음과 같은 행위를 금지합니다.',
    discription2: [
      [
        '1.',
        '이용신청 또는 이용계약 변경시 허위 사실을 기재하거나, 제3자의 명의, 결제정보 등을 도용 또는 부정하게 사용하거나, 타인의 이동전화를 부정하게 사용하여 도로로 서비스를 이용하는 행위',
      ],
      [
        '2.',
        '회원의 계정 또는 도로로 이용계약 상의 지위를 타인에게 대여하거나 판매, 양도, 증여, 담보제공 등을 하는 행위',
      ],
      [
        '3.',
        '도로로 또는 도로로 서비스를 통하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위',
      ],
      [
        '4.',
        '회사가 제공하는 도로로 서비스, 유료서비스, 제휴서비스 등의 정당한 이용방법에 의하지 않고, 도로로 시스템 내 정보를 변경하는 등 비정상적인 방법으로 위 서비스들을 이용하거나 시스템 등에 접근하는 행위',
      ],
      [
        '5.',
        '물품판매 또는 용역제공을 가장하여 자금을 융통하는 것과 같이 여신전문금융업법 등 관련법령에 의하여 금지된 방법으로 비정상적인 결제를 하는 등의 부정거래 행위 ',
      ],
      [
        '6.',
        '회사 또는 제3자의 명예를 훼손하거나 각종 권리를 침해하거나 부적절한 행위로 인하여 손해를 입히는 행위',
      ],
      [
        '7.',
        '도로로 이용 과정에서 1) 법령, 공공질서 및 미풍양속에 위반되는 내용, 2) 타인의 권리를 직접 침해하거나 권리 침해를 유도하는 내용, 3) 허위의 정보, 문장, 도형, 음성, 화상 또는 영상 등, 4) 음란하거나 수치심, 혐오감 또는 공포심을 일으키는 문장, 도형, 음향, 화상 또는 영상 등, 5) 사행행위 및 음행 또는 그 매개에 관련된 내용을 적시하거나 유포하는 행위',
      ],
      [
        '8.',
        '도로로 와 관련된 시스템 및 설비 등의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 소프트웨어 바이러스, 기타 컴퓨터 코드, 파일, 프로그램 등을 등록 또는 유포하는 행위',
      ],
      [
        '9.',
        '회사가 정한 정당한 이용방법에 의하지 않거나 부정한 방법으로 도로로 포인트 또는 혜택 등을 취득하거나 사용하는 행위',
      ],
      [
        '10.',
        '불법프로그램 또는 변조된 프로그램 등을 사용하여 정상적인 도로로 서비스 제공을 방해하는 행위',
      ],
      [
        '11.',
        '이용의사 없이 반복적인 예약 및 취소 등을 통해 회사의 도로로 서비스 제공을 방해하는 행위',
      ],
      [
        '12.',
        '고의적으로 결제 미수를 발생시키거나 미수가 장기간 발생되어 정상적인 도로로 서비스 이용으로 보기 어려운 행위',
      ],
      ['13.', '타인의 개인정보를 수집, 저장, 공개하는 행위'],
      [
        '14.',
        '회사의 직원이나 운영자를 가장⬝사칭하거나, 타인의 명의를 도용하여 도로로 또는 도로로 서비스와 관련된 글을 홈페이지 또는 인터넷 사이트 등에 게시하거나 회사 또는 제3자에게 E-mail 등을 발송하는 행위',
      ],
      ['15.', '운전연수 서비스 관련 다음의 행위'],
    ],
    discription3: [
      [
        '○',
        '회사 또는 제휴사의 차량을 절도하거나, 임의의 잠금장치를 이용하여 사유화하거나, 숨겨진 장소에 주차하는 등 자전거의 회수 또는 발견을 어렵게 하는 행위',
      ],
      [
        '○',
        '회사 또는 제휴사의 차량을 제3자에게 유상으로 제공(임대, 양도 등을포함하며 이에 한정되지 않음)하는 행위',
      ],
      [
        '○',
        '회사 또는 제휴사의 차량에 적정인원 이상의 인원을 동시에 탑승하거나 동물 또는 다른 이용자들에게 피해를 주는 물건 등과 함께 탑승하는 행위',
      ],
      [
        '○',
        '회사 또는 제휴사의 차량을 파손하거나, 개인 용도로 개조⬝수리⬝변형하는 행위 또는 차량에 부착된 각종 장비를 임의로 제거하거나 다른 용도로 사용하는 행위',
      ],
      [
        '○',
        '회사 또는 제휴사의 차량을 이용하여 관련법령상 자동차 주행이 금지된 지역에서 주행하는 행위',
      ],
    ],
  },
  {
    discription2: [
      ['16.', '관련법령 또는 본 약관 및 운영정책 등을 위반하는 행위'],
      ['17.', '기타 불법적이거나 부적절한 행위'],
    ],
    lineBreak: true,
  },
  {
    title2: '제17조 개인정보 보호 등',
    discription2: [
      [
        '1.',
        '회사는 회원이 안전하게 도로로 서비스를 이용할 수 있도록 회원의 개인정보, 위치정보, 신용정보 등(이하 “개인정보 등"이라 함)을 보호하기 위하여 관련법령에 따라 보안 시스템 등을 갖추고 개인정보 등 보호 정책을 실시합니다.',
      ],
      [
        '2.',
        '회사는 회원의 개인정보 등을 관련법령상 필요한 경우 등을 제외하고 도로로 서비스를 제공하기 위한 목적 이외의 용도로 사용하거나 회원의 동의 없이 제3자에게 제공하지 않습니다.',
      ],
      [
        '3.',
        '회사는 수집된 개인정보 등의 취급과 관리 등의 업무를 스스로 수행함을 원칙으로 합니다. 다만, 회사는 필요한 경우 회원의 동의를 받거나 통지를 한 후 위 업무의 일부 또는 전부를 회사가 선정한 회사에 위탁할 수 있습니다.',
      ],
      [
        '4.',
        '회원은 이용신청 당시 기재한 사항이 변경되었을 경우에는 즉시 변경사항을 최신의 정보로 수정하여야 합니다. 다만, 회사가 정한 정보 항목은 회사의 승인을 받아 수정할 수 있습니다.',
      ],
      [
        '5.',
        '전항에 따라 수정하지 않은 정보로 인하여 발생하는 손해는 당해 회원이 부담하고, 회사는 이에 대하여 귀책사유가 없으면 책임을 지지 않습니다.',
      ],
      [
        '6.',
        '회원이 이용계약을 해지하는 경우, 회사는 관련법령 및 개인정보처리방침에 따라 회원의 개인정보 등을 보유하는 경우를 제외하고 해지 즉시 회원의 모든 정보를 삭제합니다.',
      ],
      [
        '7.',
        '회사의 개인정보 등 보호와 관련한 상세한 내용은 회사가 회사의 홈페이지 또는 도로로 내에 게시하는 개인정보처리방침에 따릅니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title1: '제 5장 기타',
    title2: '제18조 손해배상',
    discription2: [
      [
        '1.',
        '회원이 관련법령 또는 본 약관 및 회사가 정한 운영정책 등을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 해당 회원은 회사에 발생한 손해를 배상하여야 합니다.',
      ],
      [
        '2.',
        '회원이 도로로 또는 도로로 서비스를 이용함에 있어 행한 불법행위나 제1항의 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 당해 회원은 회사의 고의 또는 과실이 없는 한 자신의 책임과 비용으로 회사를 면책시켜야 하고, 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.',
      ],
      [
        '3.',
        '회사의 고의나 과실에 의하여 회원에게 손해가 발생한 경우, 회사는 회원에게 해당 손해를 배상하여야 합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제19조 분쟁의 해결 및 관할법원',
    discription2: [
      [
        '1.',
        '회사는 도로로 서비스의 이용과 관련한 불만사항 등의 처리를 위한 고객센터를 운영합니다.',
      ],
      [
        '2.',
        '도로로 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 분쟁의 해결을 위해 성실히 협의합니다.',
      ],
      [
        '3.',
        '회사와 회원 사이에 제기된 소송은 대한민국법을 준거법으로 합니다.',
      ],
      [
        '4.',
        '회사와 회원 사이에 발생한 분쟁에 관한 소송의 관할법원은 민사소송법에 따라 정합니다.',
      ],
    ],
    lineBreak: true,
  },
];
